"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadiuses = void 0;
var borderRadiuses = exports.borderRadiuses = {
  borderRadiusSmall: '4px',
  borderRadiusMedium: '8px',
  borderRadiusXMedium: '12px',
  borderRadiusLarge: '16px',
  borderRadiusXLarge: '24px'
};